// extracted by mini-css-extract-plugin
export default {"modalOverlay":"SP-z","modalContent":"TP-z","header":"UP-z","close":"VP-z"};